import { Formatters } from '@billy/design-system'
import { TFunction } from 'i18next'

interface BuildFlatReportHeaderProps {
  locale?: string
  name: string
  periodText: string
  t: TFunction
}

export const buildFlatReportHeader = ({ locale, name, periodText, t }: BuildFlatReportHeaderProps) => {
  const intlLocale = Formatters.getFormatLocale(locale ?? 'da_DK')

  const generatedTimeFormatted = new Intl.DateTimeFormat(intlLocale, {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date())

  return [
    [t('vat_declaration.export.header.title', { period: periodText })],
    [name, t('vat_declaration.export.header.generated_time', { generatedTime: generatedTimeFormatted })],
  ]
}
